import { useParams, useLocation } from 'react-router-dom';
import { 
    removeProperUserRoleEndpoint,
    getProperUserAssignedRolesEndpoint,
    updateProperUserRolesEndpoint
} from '../propers/services/rolesService';

import RolesManagement, { RolesService } from '../../components/RolesManagement'; 

const InternalUserRolesManagement = () => {
  const { userId = '' } = useParams();
  const location = useLocation();
  const userEmail = location.state?.userEmail || ''; 

  const internalUserServices: RolesService = {
    getUserRoles: (uId, token) => getProperUserAssignedRolesEndpoint(token, uId),
    assignRole: (uId, roleId, token) => updateProperUserRolesEndpoint(token, uId, roleId),
    removeRole: (uId, roleId, token) => removeProperUserRoleEndpoint(token, uId, roleId),
  };

  return (
    <RolesManagement
      userId={userId}
      userEmail={userEmail}
      service={internalUserServices}
      pageName="Administración de Roles"
      pageParentName="Propers"
    />
  );
};

export default InternalUserRolesManagement;